import { render, staticRenderFns } from "./FieldBlock.vue?vue&type=template&id=70e89ef6"
import script from "./FieldBlock.vue?vue&type=script&lang=ts"
export * from "./FieldBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports